module.exports = __webpack_public_path__ + "img/Capture13.dab8ea9b.jpg";